/* unplugin-vue-components disabled */import { render } from "./ImageManager.vue?vue&type=template&id=34880822&scoped=true"
import script from "./ImageManager.vue?vue&type=script&lang=js"
export * from "./ImageManager.vue?vue&type=script&lang=js"

import "./ImageManager.vue?vue&type=style&index=0&id=34880822&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34880822"]])

export default __exports__